import { SUPPORT_EMAIL } from '../config/publicResources';

interface SupportEmailOptions {
  appVersion: string;
  accountEmail: string;
  subject?: string;
}

type MailtoLauncher = (uri: string) => void;

export function buildSupportMailto({
  appVersion,
  accountEmail,
  subject = 'Rubikoo Conference App - Support & Feedback',
}: SupportEmailOptions): string {
  const body = `\n\n\n---\nDiagnostics (please keep):\nApp version: ${appVersion}\nAccount: ${accountEmail || 'unknown'}`;
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function openSupportEmail(
  options: SupportEmailOptions,
  launch: MailtoLauncher = (uri) => window.location.assign(uri),
): boolean {
  try {
    launch(buildSupportMailto(options));
    return true;
  } catch {
    return false;
  }
}
